import $ from 'jquery';

$(document).ready(() => {
	$('.faqs a[data-toggle]').bind('click', function (e) {
		e.preventDefault();
		const $parent = $(this).closest('.faqs__item');
		if ($parent.hasClass('active')) {
			$parent.removeClass('active');
			$parent.find('.faqs__answer').slideUp();
		} else {
			$parent.addClass('active');
			$parent.find('.faqs__answer').slideDown();
		}
	});
});
